"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    AutocompleteContainer: ()=>AutocompleteContainer
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const AutocompleteListItem_cjs_namespaceObject = require("./AutocompleteListItem/AutocompleteListItem.cjs");
const AutocompleteListItem_variant_cjs_namespaceObject = require("./AutocompleteListItem/AutocompleteListItem.variant.cjs");
function getIconName(itemLocationType) {
    if ('AIRPORT' === itemLocationType) return 'flight_takeoff';
    if ('POI' === itemLocationType) return 'location_on';
    if ('GEO' === itemLocationType) return 'my_location';
    return 'location_city';
}
function AutocompleteContainer({ items, isOpen, highlightedIndex, highlightedIndexWithKeyArrow, selectedItem, getItemProps }) {
    const { groupHeaderWrapper } = (0, AutocompleteListItem_variant_cjs_namespaceObject.autocompleteListItemVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
        children: isOpen && items.length > 0 && items.map((item, index)=>item.isGroupHeader ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: groupHeaderWrapper(),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                    textStyle: "body3",
                    color: "primary-13",
                    children: item.itemName
                })
            }, `${item.itemName}`) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(AutocompleteListItem_cjs_namespaceObject.AutocompleteListItem, {
                firstLine: item.displayLine1 ?? item.itemName,
                secondLine: item.displayLine2 ?? void 0,
                leftNode: item.type && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                    palette: "primary",
                    shade: "10",
                    iconName: getIconName(item.type),
                    size: "24"
                }),
                isHighlighted: highlightedIndex === index && 'GEO' !== item.type,
                isHighlightedIndexWithKeyArrow: highlightedIndexWithKeyArrow === index,
                isSelected: selectedItem?.itemName === item.itemName && 'GEO' !== item.type,
                ...getItemProps({
                    item,
                    index
                })
            }, `${item.itemName}`))
    });
}
exports.AutocompleteContainer = __webpack_exports__.AutocompleteContainer;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "AutocompleteContainer"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
